<div class="page-wrapper">
  <aside *ngIf="!isAnonymous">
    <router-outlet name="navigation"></router-outlet>
  </aside>

  <main
    class="content"
    [ngClass]="{
      'no-overflow': searchActive
    }"
  >
    <router-outlet #outlet="outlet"></router-outlet>
  </main>
  <app-search-filter-overlay
    *ngIf="!isAnonymous"
    [ngClass]="{ open: this.searchFilterService.filterOpen }"
  ></app-search-filter-overlay>
  <app-cart *ngIf="!isAnonymous" [ngClass]="{ open: this.cartOpen }"></app-cart>
</div>
